/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import BookingStepItem from "../booking/steps/BookingStepItem";
import Skeleton from "./Skeleton";
import SkeletonText from "./SkeletonText";
import Flex from "../ui/Flex";

// Mirrors booking/product/ProductsCategoryItem.jsx
const StyledItem = styled((props) => <BookingStepItem {...props} />)`
  width: 100%;
  padding: 0.5rem;
  break-inside: avoid;
  border-radius: 1rem;
  min-height: 410px;
`;

const ProductsCategoryItemSkeleton = () => (
  <StyledItem>
    <Skeleton borderRadius={8} width="100%" height={228} />
    <Flex $direction="column" $gap="0.5rem" $padding="0.5rem">
      <Flex $justify="space-between" $gap="0.6rem">
        <SkeletonText size="large" width="55%" />
        <SkeletonText size="large" width="20%" />
      </Flex>
      <SkeletonText size="small" lines={2} />
    </Flex>
  </StyledItem>
);

export default ProductsCategoryItemSkeleton;
